import { Link } from "react-router-dom";
import headerLogo from "../../../assets/logos/masar-logo-header.png"
// import { useLangUrl } from "../../../utilities/useLangUrl";

export default function HeaderLogo() {
    // const langUrl = useLangUrl();

    return (
        <Link to={`/`} className="col-2">
            <img className="logo-header my-2" src={headerLogo} alt="Masar logo" />
        </Link>
    )
}